import { of } from 'rxjs';
import { map } from 'rxjs/operators';

export default function(fn) {

  const cache = new Map();

  return function(...args) {
    const key = args.join('-');

    if (cache.has(key)) {
      return of(cache.get(key));
    }

    return fn(...args)
      .pipe(
        map(function(result) {
          cache.set(key, result);
          return result;
        })
      );
  };
};
